<template>
    <div class="land-layout-container">
        <div class="land-layout-content">
            <slot name="buy">
                <div class="product-buy-slot"></div>
            </slot>
            <slot name="intro">
                <div class="product-intro-slot"></div>
            </slot>
            <requirement
                :name="name"
                :type="type"
            />
        </div>
        <company-banner/>
    </div>
</template>

<script>
import { isOnline } from '../util/helper';
import CompanyBanner from './CompanyBanner.vue';
import Requirement from './NewRequirement.vue';
export default {
    props: {
        type: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        }
    },
    name: 'Home',
    components: {
        CompanyBanner,
        Requirement
    },
    created() {
        let scriptNode = document.createElement('script');
        let scriptSrc = isOnline
            ? 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.online.js'
            : 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.sandbox.js';
        scriptNode.setAttribute('src', scriptSrc);
        scriptNode.onload = () => {
            if (window.portalCommon) {
                window.portalCommon.setup({
                    showHeader: true,
                    showPcFooter: true,
                    showWapFooter: true
                });
            }
        };
        document.head.appendChild(scriptNode);
    }
};
</script>

<style lang="less" scoped>
.land-layout-container {
    background: #f5f5f5;
    .land-layout-content {
        width: 1200px;
        margin: 20px auto 80px;
        margin-top: 0;
        position: relative;
    }
    .product-buy-slot {
        width: 930px;
        height: 501px;
        background: #ffffff;
        margin-bottom: 16px;
    }
    .product-intro-slot {
        width: 930px;
        height: 501px;
        background: #ffffff;
    }
}
</style>
